import { Navigate } from 'react-router-dom';
import SelectOrg from './SelectOrg';
import { useOrgContext } from '../../context/org';

function Organization() {
	const {org} = useOrgContext()

	return (
		<>
			{ !org ? <SelectOrg/> : <Navigate to={`/dashboard/orgs/${org.id}`} />}
		</>
	)
}

export default Organization